const display2xl = {
  fontSize: '60px',
  lineHeight: '72px',
  letterSpacing: '-0.02em'
};
const display1xl = {
  fontSize: '48px',
  lineHeight: '60px',
  letterSpacing: '-0.02em'
};
const displayXl = {
  fontSize: '36px',
  lineHeight: '44px',
  letterSpacing: '-0.02em'
};
const displayLg = {
  fontSize: '32px',
  lineHeight: '40px',
  letterSpacing: 0
};
const displayMd = {
  fontSize: '24px',
  lineHeight: '32px',
  letterSpacing: 0
};
const displaySm = {
  fontSize: '20px',
  lineHeight: '30px',
  letterSpacing: 0
};
const textLg = {
  fontSize: '18px',
  lineHeight: '28px',
  letterSpacing: 0
};
const textMd = {
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: 0
};
const textSm = {
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: 0
};
const textXs = {
  fontSize: '12px',
  lineHeight: '16px',
  letterSpacing: 0
};
export const fontStack = {
  display2xl,
  display1xl,
  displayXl,
  displayLg,
  displayMd,
  displaySm,
  textLg,
  textMd,
  textSm,
  textXs
};
export const fontStackMobile = {
  ...fontStack,
  display2xl: display1xl,
  display1xl: displayXl,
  displayXl: displayLg,
  displayLg: displayMd,
  displayMd: displaySm,
  displaySm: textLg
};
export default fontStack;